import { memo, type ReactNode, useState } from 'react'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

import { InvitationsListSection } from './invitations-list-section.organism'
import type { MembersTabsContentProps } from './members.interface'
import { MembersListSection } from './members-list-section.organism'

type MembersTab = 'members' | 'invitations'

const MembersTabsContentBase: React.FC<MembersTabsContentProps> = (props): ReactNode => {
  const [activeTab, setActiveTab] = useState<MembersTab>('members')
  const pendingCount = props.invitationList.filter((i) => i.status === 'pending').length

  return (
    <div className={cn('members-tabs-content', props.className)}>
      <Tabs value={activeTab} onValueChange={(v) => setActiveTab(v as MembersTab)}>
        <div className="members-tabs-header mb-4 flex items-center justify-between">
          <TabsList>
            <TabsTrigger value="members">Members ({props.memberList.length})</TabsTrigger>
            <TabsTrigger value="invitations">
              Invitations {pendingCount > 0 && `(${pendingCount})`}
            </TabsTrigger>
          </TabsList>
          {props.toolbarActions && (
            <div className="members-toolbar-actions">{props.toolbarActions}</div>
          )}
        </div>
        <TabsContent value="members" className="mt-0">
          <MembersListSection
            memberList={props.memberList}
            currentUserId={props.currentUserId}
            canManageMembers={props.canManageMembers}
            isLoading={props.isMembersLoading}
            onRoleChange={props.onRoleChange}
            onRemoveMember={props.onRemoveMember}
          />
        </TabsContent>
        <TabsContent value="invitations" className="mt-0">
          <InvitationsListSection
            invitationList={props.invitationList}
            canManageMembers={props.canManageMembers}
            isLoading={props.isInvitationsLoading}
            onRevokeInvitation={props.onRevokeInvitation}
          />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export const MembersTabsContent = memo(MembersTabsContentBase)

MembersTabsContent.displayName = 'MembersTabsContent'
